import {Link} from 'react-router-dom';
import {CollectionSubType, CollectionType} from './types';

const CollectionNavigation = ({...props}: any) => {

  const isSpecial = (collection: CollectionType) =>
    collection.slug === 'on-sale'
    || collection.slug === 'most-popular'
    || collection.slug === 'newest-items'
    || collection.id === 21000;

  return (
    <>
      <div>
        <nav
          className='flex space-x-1 px-2 md:px-4 md:space-x-2 justify-center md:justify-start overflow-x-auto'
        >

          {props.collections.length > 0 &&
            <Link
              to={`/`}
            >
              <Chip
                active={!props.activeCollection && !props.specialTab}
                special={true}
                label='All'
              />
            </Link>
          }

          {props.collections.length > 0 && props.collections.filter((c: CollectionType) => c.showInMainMenu && isSpecial(c)).map((collection: any) =>
            <Link
              key={collection.id}
              to={`/collections/${collection.slug}`}
              onClick={() => props.onCollectionSelect(collection)}
            >
              <Chip
                active={props.activeCollection?.title === collection?.title}
                special={true}
                label={collection.title}
              >
                {collection.slug === 'newest-items' && collection.newItemsCount != null && collection.newItemsCount > 0 && (
                  <span
                    style={{fontSize: '10px', lineHeight: '11px'}}
                    className='inline-flex items-center rounded-full bg-red-600 px-0.5 py-0.5 text-xs font-medium text-white'
                  >
                    {collection.newItemsCount}
                  </span>
                )}
              </Chip>
            </Link>
          )}
        </nav>
        <nav
          className='flex space-x-1 px-2 md:px-4 md:space-x-2 overflow-x-auto'
          style={{scrollbarWidth: 'thin'}}
        >
          {props.specialTab && (
            <Chip
              active={true}
              special={false}
              label={props.specialTab}
            />
          )}
          {props.collections.length > 0 && props.collections.filter((c: CollectionType) => c.showInMainMenu && !isSpecial(c)).map((collection: any) =>
            <Link
              key={collection.id}
              to={`/collections/${collection.slug}`}
              onClick={() => props.onCollectionSelect(collection)}
            >
              <Chip
                active={props.activeCollection?.title === collection?.title}
                special={false}
                label={collection.title}
              />
            </Link>
          )}
        </nav>
      </div>

      {props.activeCollection?.children && props.activeCollection?.children.length > 0 && (
        <nav
          className='py-1 bg-green-600 flex items-center px-2 md:px-4 space-x-1 md:items-center overflow-x-auto'
          style={{scrollbarColor: '#007A3E #dcfce7', scrollbarWidth: 'thin'}}
        >
          <Link
            to={`/collections/${props.activeCollection.slug}`}
            onClick={() => props.onCollectionSelect(props.activeCollection)}
          >
            <Chip
              label={`All ${props.activeCollection?.title}`}
              active={!props.activeChildCollection}
              sub={true}
            />
          </Link>

          {props.activeCollection?.children.map(
            (subCollection: CollectionSubType) =>
              <Link
                key={subCollection.id}
                to={`/collections/${subCollection.id}`}
                onClick={props.handleChildCollectionSelect}
              >
                <Chip
                  active={props.activeChildCollection?.title === subCollection?.title}
                  label={subCollection.title}
                  sub={true}
                />
              </Link>
          )}
        </nav>
      )}
    </>
  );
}

const Chip = (props: any) => {
  const dynamicClasses = (isSpecial: boolean, isActive: boolean, isSub: boolean) => {

    if (isSpecial) {
      if (isActive) {
        return 'text-white bg-red-600 rounded-md';
      } else {
        return 'text-red-600 bg-white rounded-md';
      }
    } else if (isSub) {
      if (isActive) {
        return 'text-green-600 bg-white rounded-md';
      } else {
        return 'text-white bg-green-600';
      }
    } else {
      if (isActive) {
        return 'text-white bg-green-600 rounded-t-md';
      } else {
        return 'text-green-600 bg-white rounded-t-md';
      }
    }
  };

  return (
    <div
      className={`
        relative
      text-xs md:text-sm px-1.5 py-1 md:px-2.5 leading-tight font-bold
      flex items-center justify-center transition-colors ease-in-out duration-200
      space-x-0.5
      md:space-x-1
      ${dynamicClasses(props.special, props.active, props.sub)}
      focus:outline-none focus:ring-2`}
    >
      <span className='whitespace-nowrap lineclamp-1'>
        {props.label}
      </span>
      {props.children}
    </div>
  );
}

export default CollectionNavigation;
